import { toast } from "react-toastify"

// function to navigate to the ADOPT page
export const handleAdoptNavigate = () => {
    toast.info("Still in development")
    return
}